/** Compact consecutive counts without implying unsupported player counts in gaps. */
export function formatPlayerCounts(values: number[]): string {
    const counts = [...new Set(values)].sort((a, b) => a - b);
    const ranges: string[] = [];
    for (let i = 0; i < counts.length; i++) {
        const first = counts[i]!;
        let last = first;
        while (counts[i + 1] === last + 1) last = counts[++i]!;
        ranges.push(first === last ? String(first) : `${first}–${last}`);
    }
    return ranges.join(', ') || '—';
}
